import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";

export default function SocialFooter() {
  return (
    <footer data-testid="social-footer" className="bg-[#070a12] text-slate-400 pt-16 pb-28 lg:pb-12 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-white shadow-lg overflow-hidden">
              <img src="/logo-icon.png" alt="" className="h-8 w-8 object-contain" />
            </span>
            <span className="font-display font-extrabold text-white text-lg">
              Instant Site<span className="text-cyan-400"> Revival</span>
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed">
            Helping local businesses look modern, active, and trustworthy online — websites,
            social media, and AI-powered content systems.
          </p>
          <a
            href="#contact"
            className="mt-4 inline-flex items-center gap-2 rounded-full bg-cyan-400 hover:bg-cyan-300 text-slate-900 font-bold px-4 py-2.5 text-sm transition"
          >
            Book Free Audit
          </a>
        </div>

        <div>
          <div className="text-white font-bold text-sm mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/" className="hover:text-white">Website Revival</Link></li>
            <li><Link to="/social" className="hover:text-white">Social Media Care Package</Link></li>
            <li><a href="#pricing" className="hover:text-white">Social Pricing</a></li>
            <li><a href="#ai-clone" className="hover:text-white">AI Avatar</a></li>
            <li><a href="#bundle" className="hover:text-white">Full Revival Bundle</a></li>
            <li><a href="#contact" className="hover:text-white">Contact</a></li>
          </ul>
        </div>

        <div>
          <div className="text-white font-bold text-sm mb-4">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/terms" className="hover:text-white">Terms of Service</Link></li>
            <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
          </ul>
          <div className="mt-5 rounded-xl bg-white/5 border border-white/5 p-4 text-xs leading-relaxed text-slate-400">
            Flexible monthly options available. Final terms are confirmed before starting.
          </div>
        </div>

        <div>
          <div className="text-white font-bold text-sm mb-4">Get in touch</div>
          <a
            href="https://wa.me/17865756919"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white font-bold px-4 py-2.5 text-sm hover:bg-[#1eb558] transition"
          >
            <MessageCircle size={16} /> Message Us · 786-575-6919
          </a>
          <div className="mt-4 text-sm">
            <a href="mailto:info@instantsiterevival.com" className="hover:text-white">
              info@instantsiterevival.com
            </a>
          </div>
          <div className="mt-2 text-sm text-slate-500">InstantSiteRevival.com</div>
        </div>
      </div>

      <div className="mt-12 max-w-7xl mx-auto px-5 lg:px-8 text-xs text-slate-500 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div>© {new Date().getFullYear()} Instant Site Revival. All rights reserved.</div>
        <div>Done-for-you content systems for local businesses.</div>
      </div>
    </footer>
  );
}
